import React from "react";
import Service from "../Items/Service";

const servicesData = [
  {
    id: 1,
    name: "Web Applications",
    content: "Develop Custom web App tailored for your specific business needs.",
    icon: "icon-cloud-upload",
  },
  {
    id: 2,
    name: "Website Design",
    content: "Design a fast & responsive website majorly for nice mobile-users experience.",
    icon: "icon-globe",
  },
  {
    id: 3,
    name: "Social media Ads",
    content: "Run well-targeted Ads that guarantee the yield of very high ROI.",
    icon: "icon-people",
  },
  {
    id: 4,
    name: "SEO",
    content: "Optimize your website to rank high on the world most popular search engines.",
    icon: "icon-social-google",
  },
  {
    id: 5,
    name: "Graphics Design",
    content: "Make your brand storm the market place with attractive and unique designs.",
    icon: "icon-drawer",
  },
  {
    id: 6,
    name: "Site Maintenance",
    content: "Secure your website and data from cyber attacks, data breach, XSS etc.",
    icon: "icon-settings",
  },
];

function Services() {
  return (
    <div className="row -mt-20">
      {servicesData.map((service) => (
        <div className="col-md-4 col-sm-6 mt-20" key={service.id}>
          <Service service={service} />
        </div>
      ))}
    </div>
  );
}

export default Services;
